export const REDUCER_NAVIGATION_SELECTED_MODULE = 'REDUCER_NAVIGATION_SELECTED_MODULE';
export const REDUCER_NAVIGATION_SELECTED_SUBMODULE = 'REDUCER_NAVIGATION_SELECTED_SUBMODULE';
export const CHANGE_ROUTE = 'CHANGE_ROUTE';
export const FROM_PAGE = 'FROM_PAGE'
